import {
  appointmentFiltersToSearchParams,
  type AppointmentPageFilters,
} from '@/pages/appointments/appointmentFilters';
import {
  invoiceFiltersToSearchParams,
  type InvoicePageFilters,
} from '@/pages/invoices/invoiceFilters';

export type ContextualDestination =
  | { type: 'invoices'; filters: InvoicePageFilters }
  | { type: 'appointments'; filters: AppointmentPageFilters }
  | { type: 'path'; pathname: string; search?: URLSearchParams };

export function invoiceDestination(filters: InvoicePageFilters): ContextualDestination {
  return { type: 'invoices', filters };
}

export function appointmentDestination(filters: AppointmentPageFilters): ContextualDestination {
  return { type: 'appointments', filters };
}

export function pathDestination(pathname: string, search?: URLSearchParams): ContextualDestination {
  return { type: 'path', pathname, search };
}

export function destinationHref(destination: ContextualDestination): string {
  switch (destination.type) {
    case 'invoices': {
      const query = invoiceFiltersToSearchParams(destination.filters).toString();
      return query ? `/economy/invoices?${query}` : '/economy/invoices';
    }
    case 'appointments': {
      const query = appointmentFiltersToSearchParams(destination.filters).toString();
      return query ? `/appointments?${query}` : '/appointments';
    }
    case 'path': {
      const query = destination.search?.toString();
      return query ? `${destination.pathname}?${query}` : destination.pathname;
    }
  }
}
